import { ROLES, ZVANJA } from "../data/pravilnik";

const Label = ({ children }) => (
  <label className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-1 block">{children}</label>
);

const NumberField = ({ id, value, onChange, min = 0, max = 60 }) => (
  <input
    type="number"
    inputMode="numeric"
    min={min}
    max={max}
    value={value}
    data-testid={id}
    onChange={(e) => onChange(e.target.value)}
    className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
  />
);

export const BasicInputs = ({ basic, setBasic, target, setTarget }) => {
  const zvanje = ZVANJA[target];
  const set = (key) => (val) => setBasic((b) => ({ ...b, [key]: val }));

  return (
    <section className="bg-white p-5 sm:p-6 rounded-xl shadow-sm border border-slate-200 space-y-5" data-testid="basic-inputs-panel">
      <h2 className="text-lg font-semibold text-slate-800 font-heading">Podaci za izračun</h2>

      <div>
        <Label>Ciljano zvanje</Label>
        <div className="flex flex-wrap gap-2" data-testid="target-toggle-group">
          {Object.values(ZVANJA).map((z) => (
            <button
              key={z.id}
              type="button"
              data-testid={`target-${z.id}`}
              onClick={() => setTarget(z.id)}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:outline-none ${
                target === z.id
                  ? "bg-blue-600 text-white"
                  : "bg-slate-100 text-slate-600 hover:bg-slate-200"
              }`}
            >
              {z.label}
            </button>
          ))}
        </div>
      </div>

      <div>
        <Label>Radno mjesto</Label>
        <select
          value={basic.role}
          data-testid="role-select"
          onChange={(e) => set("role")(e.target.value)}
          className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
        >
          {ROLES.map((r) => (
            <option key={r.id} value={r.id}>
              {r.label}
            </option>
          ))}
        </select>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label>Godine staža</Label>
          <NumberField id="input-staz" value={basic.staz} onChange={set("staz")} />
        </div>
        <div>
          <Label>Sati usavršavanja (5 god.)</Label>
          <NumberField id="input-kpr" value={basic.kpr} onChange={set("kpr")} max={2000} />
        </div>
      </div>

      {zvanje.prev && (
        <div>
          <Label>Godine u zvanju {zvanje.prev.zvanje}</Label>
          <NumberField id="input-prev-years" value={basic.prevYears} onChange={set("prevYears")} />
        </div>
      )}

      {target === "mentor" && (
        <p className="text-xs text-slate-500 bg-slate-50 border border-slate-200 rounded-lg p-3">
          Iznimka: u zvanje mentora moguće je napredovati i s 3–5 godina staža, uz 40 bodova iz
          najmanje 4 kategorije. Kalkulator to automatski uzima u obzir.
        </p>
      )}
    </section>
  );
};
